import uptime from './images/uptime.png'
import hosting from './images/hosting.png'
import ssl from './images/ssl.png'
import support from './images/support.png'
import './advantages.scss'

function Advantages() {
    return(
        <div className='advantages'>
            <div className='advantage'>
                <img src={uptime} alt='uptime' className='advantage__img'/>
                <div className='advantage__title'>99.9% Uptime</div>
                <div className='advantage__text'>
                    We Keep Your Web build Online 24x7x365.
                    Downtime not only costs you lost visitors but also damages your reputation and search engine rankings.
                </div>
            </div>
            <div className='advantage'>
                <img src={hosting} alt='hosting' className='advantage__img'/>
                <div className='advantage__title'>Blazing Fast Web Hosting</div>
                <div className='advantage__text'>
                    We Keep Your Web build Online 24x7x365.
                    Downtime not only costs you lost visitors but also damages your reputation and search engine rankings.
                </div>
            </div>
            <div className='advantage'>
                <img src={ssl} alt='ssl' className='advantage__img'/>
                <div className='advantage__title'>Free SSL Certificates</div>
                <div className='advantage__text'>
                    We Keep Your Web build Online 24x7x365.
                    Downtime not only costs you lost visitors but also damages your reputation and search engine rankings.
                </div>
            </div>
            <div className='advantage'>
                <img src={support} alt='support' className='advantage__img'/>
                <div className='advantage__title'>24x7 Friendly Support</div>
                <div className='advantage__text'>We Keep Your Web build Online 24x7x365.
                    Downtime not only costs you lost visitors but also damages your reputation and search engine rankings.</div>
            </div>
        </div>
    )
}

export default Advantages
